import {post} from '@/utils/request';
import {erpserver,erpplatserver,oaserver,sse_url} from '@/utils/baseUrl';
//列表
// export async function getAcceptanceBillList(params) {
//     return post(oaserver+'/payment/excel/getAcceptanceBillList', params, true);
// }
//贴现 托收
export async function discountAcceptanceBill(params) {
    return post(oaserver+'/payment/excel/discountAcceptanceBill', params, true);
}
//公司
export async function getCompanyList(params) {
    return post(erpserver+'/currency/getCompanyList', params, true);
}
//银行帐号
export async function getAccountByGsid(params) {
    return post(oaserver+'/payment/excel/getAccountByGsid', params, true);
}
export async function getAcceptanceBillList(params) {
    return post(oaserver+'/payment/excel/getAcceptanceBillList', params, true);
}